import Page from 'src/apipages/reference/[group]/index';

export default Page;
